import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import "./loaders.css";

/**
 * Thin top progress bar shown on route navigation (YouTube / Vercel style).
 * Non-blocking and purely visual — it does not gate any rendering.
 */
const RouteLoader = () => {
  const location = useLocation();
  const [width, setWidth] = useState(0);
  const [visible, setVisible] = useState(false);
  const timers = useRef([]);

  useEffect(() => {
    timers.current.forEach(clearTimeout);
    timers.current = [];

    setVisible(true);
    setWidth(0);

    const schedule = (fn, ms) => {
      const t = setTimeout(fn, ms);
      timers.current.push(t);
    };

    schedule(() => setWidth(35), 20);
    schedule(() => setWidth(72), 180);
    schedule(() => setWidth(100), 480);
    schedule(() => setVisible(false), 760);
    schedule(() => setWidth(0), 1080);

    return () => {
      timers.current.forEach(clearTimeout);
      timers.current = [];
    };
  }, [location.pathname]);

  return (
    <div
      className="xc-route-loader"
      role="progressbar"
      aria-hidden={!visible}
      aria-label="Page loading"
    >
      <div
        className="xc-route-loader__bar"
        style={{ width: `${width}%`, opacity: visible ? 1 : 0 }}
      />
    </div>
  );
};

export default RouteLoader;
